import { TEMP } from "@zapier/canvas-constants";
import { Edge } from "@xyflow/react";

export function isTempEdge(edge: Edge) {
  return edge.className === TEMP;
}
